<template>
  <div class="custom-offer-selecition-data">
    <div class="data-box-header">
      <em class="n-i"
          :class="[allDataActive ? 'n-i-checkbox-a' : 'n-i-checkbox']"
          @click="changeState"></em>
      <div class="cell-name">{{translation | translate}}</div>
    </div>
    <vue-scroll>
      <div class="data-box-body"
           v-if="data.length">
        <div class="searched-box">
          <input type="text"
                 v-model="searchedValue"
                 :placeholder="translate('general_search')">
        </div>
        <div class="searched-data-box">
          <div class="searched-data-box-row"
               :class="{
            'active': item.id === active && name !== 'events',
          }"
               v-for="(item, index) in filterData"
               :key="index">
            <div class="data-left">
              <div class="checkbox">
                <em class="n-i"
                    :class="[item.active ? 'n-i-checkbox-a' : 'n-i-checkbox']"
                    @click="toggleState(item)"></em>
              </div>
              <div class="flag-display"
                   v-if="['categories', 'events'].indexOf(name) >= 0">
                <em v-if="name === 'categories'"
                    class="flag"
                    :class="[`flag-${item.isoCode ? item.isoCode.toLowerCase() : 'int'}`]"></em>
                <span v-else>{{item.displayId}}</span>
              </div>
              <div class="name overflow-text"
                   :class="{
                'have-flag': name === 'categories',
                }">
                <span class="overflow-text">{{item.name}}</span>
                <span class="name-time"
                      v-if="name === 'events'">
              {{item.time}}
            </span>
              </div>
            </div>
            <div class="data-right">
              <div class="position-box">
                <input type="number"
                       :placeholder="translate('admin_position')"
                       v-model="item.position">
              </div>
              <div class="activate-row"
                   v-if="!(name === 'markets' && template === 'tournaments') && name !== 'events'"
                   @click="$emit('getSelection', {
                 name,
                 data: item,
               })">
                <em class="n-i n-i-arrow-right-d"></em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import { filter, forEach } from 'lodash';
import { mapGetters } from 'vuex';
import EventBus from '@/store/EventBus';

export default {
  name: 'CustomOfferSelecitionData',
  data() {
    return {
      searchedValue: '',
    };
  },
  props: [
    'data',
    'name',
    'active',
    'template',
    'translation',
  ],
  computed: {
    ...mapGetters([
      'translate',
    ]),
    filterData() {
      return this.searchedValue
        ? filter(this.data, (item) => {
          const type = this.name !== 'events' ? 'name' : 'time';
          return item[type].toLowerCase()
            .indexOf(this.searchedValue.toLowerCase()) >= 0;
        }) : this.data;
    },
    allDataActive() {
      let allActive = false;
      const dataLength = this.filterData.length;
      if (dataLength) {
        const temporaryLength = filter(this.filterData, item => item.active).length;
        allActive = dataLength === temporaryLength;
      }
      return allActive;
    },
  },
  methods: {
    changeState(event) {
      if (this.filterData.length) {
        const checked = event.target.classList.contains('n-i-checkbox-a');
        EventBus.$emit('activateTemporarySelection', {
          name: this.name,
          data: this.filterData[0],
          direction: !checked ? 'up' : 'down',
        });
        forEach(this.filterData, (item) => {
          // eslint-disable-next-line no-param-reassign
          item.active = !checked;
        });
      }
    },
    toggleState(item) {
      // eslint-disable-next-line no-param-reassign
      item.active = !item.active;
      EventBus.$emit('activateTemporarySelection', {
        name: this.name,
        data: item,
        direction: item.active ? 'up' : 'down',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-offer-selecition-data {
  display: flex;
  flex-direction: column;
  &.is-last {
    .data-left {
      width: calc(100% - 85px) !important;
    }
    &.events {
      .data-left {
        .name > span:first-child {
          width: 75%;
        }
      }
    }
  }
  .data-box-header {
    align-items: center;
    background: #7E8B9E;
    color: #fff;
    display: flex;
    height: 30px;
    padding: 0 10px;
    em {
      cursor: pointer;
    }
    > div {
      padding-left: 10px;
    }
    .cell-name {
      text-transform: capitalize;
    }
  }
  .data-box-header,
  .data-box-body,
  .searched-box,
  .searched-data-box,
  input {
    width: 100%;
  }
  .searched-box {
    padding: 10px 10px;
    input {
      border: 1px solid #DEE3E5;
      color: inherit;
      height: 30px;
      padding: 0 10px;
    }
  }
  .searched-data-box {
    border-top: 1px solid #DEE3E5;
  }
  .searched-data-box-row {
    border-bottom: 1px solid #DEE3E5;
    justify-content: space-between;
    width: 100%;
    &:hover,
    &.active {
      background: #009AFF;
      color: #fff;
      input {
        color: #6b7585 !important;
      }
    }
    .data-left {
      padding-left: 10px;
      width: calc(100% - 110px);
      div:not(:first-child) {
        padding-left: 10px;
      }
      .checkbox {
        cursor: pointer;
      }
      .name {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 32px);
        &.have-flag {
          width: calc(100% - 48px);
        }
        > span {
          display: inline-block;
          &:first-child {
            //width: auto;
          }
          &.name-time {
            width: 25%;
            padding-left: 5px;
            text-align: right;
          }
        }
      }
    }
    .data-right {
      padding-left: 10px;
      div:not(:last-child) {
        padding-left: 10px;
      }
      .position-box:last-child {
        margin-right: 5px;
      }
    }
    .position-box {
      padding-right: 5px;
      width: 60px;
      input {
        border: 1px solid #DEE3E5;
        color: inherit;
        height: 26px;
        padding: 0 7px;
        text-transform: capitalize;
      }
    }
    .activate-row {
      border-left: 1px solid #DEE3E5;
      cursor: pointer;
      font-size: 10px;
      justify-content: center;
      width: 30px
    }
  }
  .searched-data-box-row,
  .data-left,
  .data-right,
  .activate-row {
    align-items: center;
    height: 30px;
  }
  .searched-data-box-row,
  .data-left,
  .data-right,
  .checkbox,
  .flag-display,
  .activate-row {
    display: flex;
  }
}
</style>
